import type { AppState, Enrollment } from './types'
import { enrollmentName } from './enrollment'

const names = new Intl.Collator('es', { sensitivity: 'base', usage: 'sort' })
export const compareRosterNames = (a: { name: string; cui: string }, b: { name: string; cui: string }) =>
  names.compare(a.name, b.name) || (a.cui < b.cui ? -1 : a.cui > b.cui ? 1 : 0)

// Copy rather than reorder the repository's authoritative arrays.
export function orderedEnrollments(app: AppState, rows: Enrollment[]) {
  const students = new Map(app.students.map(s => [s.id, s]))
  const key = (e: Enrollment) => {
    const s = students.get(e.studentId)
    return { name: s ? enrollmentName(e, s) : e.name || '', cui: s?.cui || '' }
  }
  return [...rows].sort((a, b) => compareRosterNames(key(a), key(b)))
}
